import Vue from "vue"

export default {
  setTree(state, tree){
    state.tree = tree
  },
  
  //Установка поста
  setPost(state, { id, post }) {
    Vue.set(state.posts, id, post)
  },

  //Установка контейнера
  setContainer(state, { id, container }) {
    Vue.set(state.containers, id, container)
  },

  //Установка постов
  setPosts(state, list = []) {
    let posts = Object.assign({}, state.posts)
    
    list.forEach(el => {
      posts[el.id] = el
      // posts[el.id] = Object.assign({}, el, { loaded: true })
    })
    
    state.posts = posts
  },
  
  addPosts(state, list = []){
    list.forEach(item => {
      Vue.set(state.posts, item.id, item)
    })
  },

  //Установка контейнеров
  setContainers(state, list = []) {
    let containers = Object.assign({}, state.containers)
    list.forEach(el => {
      containers[el.id] = el
    })
    state.containers = containers
  },
  
  addContainers(state, list = []){
    list.forEach(item => {
      Vue.set(state.containers, item.id, item)
    })
  },
  
  deletePost(state, id){
    if(state.posts[id]){
      delete state.posts[id]
    }
  },
  
  deleteContainer(state, id){
    if(state.containers[id]){
      delete state.containers[id]
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/org/store/common/org/mutations.js